import React from 'react';
import Image from 'next/image';
import { clsx, type ClassValue } from 'clsx';
import { WebBodyText14, WebCaption12 } from '@fintronners/react-ui/src/GlobalStyling/webTypography';
import { ChevronRightDarkIcon } from '@/assets/icons';
import tailwindConfig from '@/tailwind.config';
import resolveConfig from 'tailwindcss/resolveConfig';

const fullConfig = resolveConfig(tailwindConfig);

type ListItemButtonProps = {
  title: string;
  subtitle?: string;
  rightContent?: React.ReactNode;
  className?: ClassValue;
  onClick?: () => void;
};

const ListItemButton = ({
  title,
  subtitle,
  rightContent,
  className,
  onClick,
}: ListItemButtonProps) => {
  return (
    <button
      onClick={onClick}
      className={clsx(
        'border-b-grey25 flex w-full items-center justify-between border-b py-5',
        className,
      )}
    >
      <div className="flex flex-col items-start gap-[5px]">
        <WebBodyText14.Regular className="text-darkestBlue text-left">
          {title}
        </WebBodyText14.Regular>
        <WebCaption12.Regular className="text-grey55 text-left">{subtitle}</WebCaption12.Regular>
      </div>

      <div className="flex items-center space-x-3">
        {rightContent}

        <Image src={ChevronRightDarkIcon} width={8} color={fullConfig.theme.colors.grey55} alt="" />
      </div>
    </button>
  );
};

export default ListItemButton;
export type { ListItemButtonProps };
